/**
 * One user search result, shared by UserEmailSearchField and AddUserList.
 *
 * A picker that needs one account kind greys out the other kind and says why.
 * The spoke request needs normal accounts (they have a mailbox) for the owners
 * and admins, and admin accounts (they get Databricks access) for the data
 * personas.
 */
import {
  AccountKind,
  AccountKindValue,
  accountKindOf,
} from '@internal/datasphere-personas';

export interface UserOptionValue {
  email: string;
  displayName: string;
}

export const WRONG_ACCOUNT_KIND_HINT: Record<AccountKindValue, string> = {
  [AccountKind.Normal]: 'Admin account: pick their normal account',
  [AccountKind.Admin]: 'Not an admin account: pick their admin account',
};

/** Whether a picker that needs `required` must refuse `user`. */
export const isWrongAccountKind = (
  user: UserOptionValue,
  required: AccountKindValue | undefined,
): boolean => required !== undefined && accountKindOf(user) !== required;

export const UserOption = ({
  user,
  accountKind,
}: {
  user: UserOptionValue;
  accountKind?: AccountKindValue;
}) => (
  <span>
    <strong>{user.displayName}</strong>
    {user.displayName !== user.email && (
      <span style={{ color: '#666', marginLeft: 8 }}>{user.email}</span>
    )}
    {accountKind && isWrongAccountKind(user, accountKind) && (
      <span style={{ marginLeft: 8, fontStyle: 'italic' }}>
        ({WRONG_ACCOUNT_KIND_HINT[accountKind]})
      </span>
    )}
  </span>
);
